import React from 'react';
import Contact2 from '../../components/ContactElements/Contact2';
import Contact3 from '../../components/ContactElements/Contact3';
import PageHeader from '../Shared/PageHeader';

const Contact02 = () => {
    return (
        <div>
            <PageHeader title="Contact Us"></PageHeader>
            <div className="main-wrapper">
                <div className="contact">
                    <div className="container">
                        <Contact2></Contact2>
                        <Contact3></Contact3>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Contact02;